import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import EnigmIm from '../../../images/sess14Im.png';

const Session14 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQ1, setRespQ1] = React.useState('');
  const [respQ2, setRespQ2] = React.useState('');
  const [respQ3, setRespQ3] = React.useState('');
  const [respQ4, setRespQ4] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour et bienvenue !</h3>
            <p>
              Aujourd’hui, nous allons continuer notre découverte de l’altruisme
              dans les différentes cultures.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1x-yDxr6NSf3_G3b5MWRc6LXjtYqR56NF-_oVq7TJEtk"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Dans la vidéo, les personnes âges accompagnent les enfants :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="ecole"
                  control={<Radio />}
                  label="A l’école le matin"
                />
                <FormControlLabel
                  value="cantine"
                  control={<Radio />}
                  label="Lors du repas à la cantine"
                />
                <FormControlLabel
                  value="bibliothèque"
                  control={<Radio />}
                  label="A la bibliothèque l’après-midi"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>Place à une nouvelle énigme !</p>
            <p>
              Imagine que tu rencontres quatre garçons au parc, mais tu as
              oublié leurs prénoms… Nous avons quelques indices pour t’aider à
              les retrouver.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>Lis bien les indices en regardant attentivement l’image.</p>
            <p>
              Une fois que tu penses savoir qui est qui, rentre leurs noms de
              gauche à droite dans les cases correspondantes.{' '}
            </p>
            <img
              src={EnigmIm}
              alt="code"
              style={{width: '50%', marginLeft: '20%'}}
            />
            <p style={{fontWeight: 'bold'}}>
              Quel est le prénom de chaque enfant?
            </p>
            <p>Jean est à droite de Léo mais n’est pas à côté de lui. </p>
            <p>Gabriel n’a pas de gros ballon. </p>
            <p>Nicolas aime les sports de balle mais n’aime pas les pois.</p>

            <TextField
              id="respQ1"
              label="Je joue au basket"
              variant="outlined"
              value={respQ1}
              onChange={(e) => {
                setRespQ1(e.target.value);
              }}
            />
            <TextField
              id="respQ2"
              label="Je joue au tennis"
              variant="outlined"
              value={respQ2}
              onChange={(e) => {
                setRespQ2(e.target.value);
              }}
            />
            <TextField
              id="respQ3"
              label="Je joue au football"
              variant="outlined"
              value={respQ3}
              onChange={(e) => {
                setRespQ3(e.target.value);
              }}
            />
            <TextField
              id="respQ4"
              label="Je fais du vélo"
              variant="outlined"
              value={respQ4}
              onChange={(e) => {
                setRespQ4(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              La bonne réponse était la suivante : de gauche à droite, Léo,
              Gabriel, Nicolas, Jean.
            </p>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te connecter
              dans quelques jours pour la prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors de la dernière séance, l’action de ton association avait
                rencontré un petit problème. Tu avais proposé une solution, t’en
                souviens-tu ?
              </p>
              <p>
                Heureusement grâce aux idées de tous, l’action a pu avoir lieu.
                Allons à la rencontre d’une personne qui a pu en bénéficier !
              </p>
            </div>
          )}
        {group.toString() === 'test_a' && scr === 3 && (
          <div>
            <p>
              Les parcs étaient fermés mais vous avez finalement pu vous rendre
              aux abords d’une rivière pour nettoyer les espaces de promenade.
            </p>
            <p>
              Anne, qui s’y promène tous les matins et nourrit les oiseaux,
              était ravie : « Les promeneurs jettent souvent leur poubelle au
              sol et c’est très embêtant car les oiseaux finissent par avaler le
              plastique. Grâce à vous, les randonnées sont plus agréables, et
              les oiseaux sont moins en danger. »
            </p>
            <p>
              A ton avis, comment s’est sentie Anne en se promenant après le
              nettoyage par ton association ? Quelles ont pu être ses pensées ?
              Tu peux écrire tes idées ci-dessous.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes idées"
              variant="outlined"
              value={respQ1}
              onChange={(e) => {
                setRespQ1(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}

        {group.toString() === 'test_b' && scr === 3 && (
          <div>
            <p>
              Le service hospitalier était fermé mais vous avez finalement pu
              vous rendre dans un autre service pour divertir des patients et
              leur chanter des chansons.
            </p>
            <p>
              Nathan, qui est hospitalisé dans ce service, était ravi : « Nous
              avons très peu de visites, et souvent les bruits dans l’hôpital
              sont des bips électroniques et des alarmes. Pouvoir voir du monde
              et écouter des chansons, c’était différent de notre vie
              quotidienne. »
            </p>
            <p>
              A ton avis, comment s’est senti Nathan en voyant ton groupe et en
              écoutant les chansons ? Quelles ont pu être ses pensées ? Tu peux
              écrire tes idées ci-dessous.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes idées"
              variant="outlined"
              value={respQ1}
              onChange={(e) => {
                setRespQ1(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}

        {group.toString() === 'test_c' && scr === 3 && (
          <div>
            <p>
              Le camion pour la distribution des plats chauds était en panne
              mais vous avez finalement pu demander au restaurant de vous aider
              en livrant les plats directement sur la place de la ville
            </p>
            <p>
              Luc, qui a pu avoir un plat chaud lors de la distribution, était
              ravi : « Quand il fait froid dehors, ça réchauffe de pouvoir
              manger un plat comme ça. En plus, c’était très bon et servi avec
              le sourire. »
            </p>
            <p>
              A ton avis, comment s’est senti Luc lorsqu’il a reçu son repas
              distribué par l’association ? Quelles ont pu être ses pensées ? Tu
              peux écrire tes idées ci-dessous.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes idées"
              variant="outlined"
              value={respQ1}
              onChange={(e) => {
                setRespQ1(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}

        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session14')
              .add({
                date: now,
                response: response,
                resp1: respQ1,
                resp2: respQ2,
                resp3: respQ3,
                resp4: respQ4,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session14;
